import { fetchApi } from 'Utils/utils';

const URL_PREFIX = '/api/v1/catalog/product/tags';

let search = function(payload) {
  return fetchApi.post(`${URL_PREFIX}/search/`, payload);
};

let create = function(payload) {
  return fetchApi.fileUpload(`${URL_PREFIX}/`, payload);
};

let update = function(tagId, payload) {
  return fetchApi.fileUpload(`${URL_PREFIX}/${tagId}/`, payload);
};

let remove = function(id) {
  return fetchApi.delete(`${URL_PREFIX}/${id}/`);
};

let find = function(id) {
  return fetchApi.get(`${URL_PREFIX}/${id}/`);
};

let findAll = function() {
  return fetchApi.get(`${URL_PREFIX}/`);
};

export { create, update, search, remove, find, findAll };
